export * from "-!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/framevuerk-builder/node_modules/pug-html-loader/lib/index.js!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/index.js??vue-loader-options!./fvListItem.vue?vue&type=template&id=65c297c2&lang=pug&"


//////////////////
// WEBPACK FOOTER
// ./src/components/fvListItem.vue?vue&type=template&id=65c297c2&lang=pug&
// module id = 120
// module chunks = 0 1